import { Box, Button, Checkbox, Container, Grid, Typography } from '@mui/material'
import React, { useState,useRef, useEffect } from 'react'
import "./signUP.styles.css"
import InputField from '../mui-components/InputField'
import logo from "../assets/images/Logo-new.svg"
import { useForm } from "react-hook-form"
import { aguserStore, configStore, loginStore } from "../state/CommonState";
import Carousel from '../mui-components/Carousel'
import { useSnapshot } from "valtio";
import Api from "../state/Api";
import UsersApis from '../state/users-api'
function LoginPageNew({callback}) {
  const [error, setError] = useState("")
  const [isToggled, setisToggled] = useState(true)
  const handleChange = (type,e)=>{
    console.log(e.target.value);
    if (type === "email") {
      e.target.value = e.target?.value?.toLowerCase()
      let emailCheck = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let ok =   emailCheck.test(e.target.value)
      console.log(ok);
      ok?setError(""):setError("Invalid email address")
    }
  }

  const loginForm = useForm({
      defaultValues:{
          email:"",
          password:"",
          rememberMe : true
      }
  })

  const {handleSubmit,register,formState:{errors},control,getValues,setValue,watch,reset} = loginForm;

  useSnapshot(configStore);
  const submit = async (data)=>{
      console.log("The data is ",data)
      try {
          // await Api.getUser(data.email.toLowerCase(), data.password,(userRec)=>{
          //     if(!userRec?.userFound){
          //         return  configStore.setModalMessage("Invalid username/password")
          //       }
          //       loginStore.isShowClientDashBoard = userRec?.aguserRec?.role
          //       .toLowerCase()
          //       .startsWith("client");
          //       if(userRec?.aguserRec?.token && userRec?.aguserRec?.token.length>0){
          //           localStorage.setItem('devicetoken', userRec.aguserRec.token)
          //           aguserStore.aguserRec.set(userRec.aguserRec);
          //           if(userRec?.aguserRec?.selectgst && userRec?.aguserRec?.selectgst.length>0){
          //             console.log("the selected  gst is ",userRec.aguserRec.selectgst)
          //             console.log("the company list is ",userRec.companyList)
          //               for (let i = 0; i < userRec.companyList.length; i++) {
          //                   if(userRec.companyList[i]['_id'] == userRec.aguserRec.selectgst){
          //                       localStorage.setItem('ag_current_entity', JSON.stringify(userRec.companyList[i]))
          //                       configStore.currentSelectedEntity = userRec.companyList[i];
          //                   }
          //               }
          //           }
          //           if(userRec?.aguserRec?.tour && userRec?.aguserRec?.tour.length>0){
          //               localStorage.setItem('tour', userRec.aguserRec.tour)
          //           }  
          //           const userRecString = JSON.stringify(userRec)
          //           console.log("the rememebere ejenej ",data.rememberMe)
          //           localStorage.setItem('ag_email', data.email)
          //           if (data.rememberMe) {
          //               localStorage.setItem("ag_remember_user",true);
          //               localStorage.setItem('ag_userrec', userRecString)
          //           }else{
          //             localStorage.setItem("ag_remember_user",false);
          //             sessionStorage.setItem('ag_userrec', userRecString)
          //           }

          //           loginStore.email = data.email; 
          //           reset();
          //         //   navigate('/',{replace:true})
          //       }
          // })
          await UsersApis.loginUser(data , (userRec)=> {
            console.log(userRec);
            if(!userRec?.userFound){
              return  configStore.setModalMessage("Invalid username/password")
            }
            if(userRec?.userFound && userRec.entityList.length === 0 && userRec?.noEntity){
              localStorage.setItem('ag_email', data.email)
              localStorage.setItem('tour', userRec?.aguserRec?.tour)
              localStorage.setItem('devicetoken', userRec?.aguserRec?.token)
              loginStore.isShowClientDashBoard = userRec?.aguserRec?.role
              loginStore.userRec.aguserRec = userRec?.aguserRec
              loginStore.email = data.email; 
              const userRecString = JSON.stringify(userRec)
              if (data.rememberMe) {
              localStorage.setItem("ag_remember_user",true);
              localStorage.setItem('ag_userrec', userRecString)
              }else{
              localStorage.setItem("ag_remember_user",false);
            // sessionStorage.setItem('ag_userrec', userRecString)
             }
            return  callback("entity")
            }
            loginStore.isShowClientDashBoard = userRec?.aguserRec?.role
            .toLowerCase()
            .startsWith("client");  
            if(userRec?.aguserRec?.token && userRec?.aguserRec?.token.length>0){
                        localStorage.setItem('devicetoken', userRec.aguserRec.token)
                        if(userRec?.aguserRec?.selectgst && userRec?.aguserRec?.selectgst.length>0){
                            for (let i = 0; i < userRec.companyList.length; i++) {
                              for(let r = 0 ; r < userRec.companyList[i].branches.length; r++ ){
                                if(userRec.companyList[i]?.branches[r]?.gst == userRec.aguserRec.selectgst){
                                  localStorage.setItem('ag_current_entity', JSON.stringify(userRec.companyList[i]))
                                  localStorage.setItem('ag_current_branch', JSON.stringify(userRec.companyList[i].branches[r]))
                          configStore.currentSelectedEntity=userRec.companyList[i]
                          configStore.currentSelectedBranch=userRec.companyList[i].branches[r]
                              }
                              }
                               
                            }
                        }else {
                          if(userRec.companyList.length > 0 ) {
                            localStorage.setItem('ag_current_entity', JSON.stringify(userRec.companyList[0]))
                            localStorage.setItem('ag_current_branch', JSON.stringify(userRec.companyList[0].branches[0]))
                            configStore.currentSelectedEntity=userRec.companyList[0]
                            configStore.currentSelectedBranch=userRec.companyList[0].branches[0]
                          }

                        }
                        // localStorage.setItem('ag_current_entity', JSON.stringify(userRec.[i]))
                        // localStorage.setItem('ag_current_branch', JSON.stringify(userRec.companyList[i]))
                        if(userRec?.aguserRec?.tour && userRec?.aguserRec?.tour.length>0){
                            localStorage.setItem('tour', userRec.aguserRec.tour)
                        }
                        localStorage.setItem('ag_email', data.email)
                        // const rememberMe = localStorage.getItem('ag_remember_user')
                        // if (rememberMe === 'REMEMBER') {
                        //     const userRecString = JSON.stringify(userRec)
                        //     localStorage.setItem('ag_userrec', userRecString)
                        // }
                        const userRecString = JSON.stringify(userRec)
                        if (data.rememberMe) {
                        localStorage.setItem("ag_remember_user",true);
                        localStorage.setItem('ag_userrec', userRecString)
                    }else{
                      localStorage.setItem("ag_remember_user",false);
                      // sessionStorage.setItem('ag_userrec', userRecString)
                    }
                    }
                   
        })
      } catch (error) {
         configStore.setModalMessage("Something went wrong")
      }
  }
  return (
    <>
  <div className='signIN_container'>
    <div className='info_container'>
      <div className='logo_container'>
      <img src={logo}></img>
      </div>
    <Typography variant="h3" fontFamily={"Figtree, sans-serif"} fontWeight={900} marginBottom={"1rem"} gutterBottom>Lead your supply chain
    with ease.</Typography>
    <Typography variant="h6" fontFamily={"Figtree, sans-serif"} color={"#555"} fontWeight={400} marginBottom={"1rem"} gutterBottom>Experience seamless solutions, Transparent value chains and Boundless trade!</Typography>
    <Carousel/>
    </div>
    <div className='field_container'>

      <form className='field_wrapper' onSubmit={handleSubmit(submit)}>
      <Typography variant="h5" fontFamily={"Figtree, sans-serif"} fontWeight={600} marginBottom={"1rem"} gutterBottom>Sign in to Agraga</Typography>
      <InputField 
      placeholder={"Enter Email"}
      label={"Email"}
      label_class={"label_styles"}
      mandatory={false}
      input_class={"inputBox_styles"}
      errorsmsg={errors?.email?.message || error}
      input_wrapeer={"input_wrapeer"}
      type={"email"}
      // onkeyup={(e)=> e.target.value = e.target?.value?.toLowerCase()}
      children={{...register("email",{onChange:(e)=>handleChange("email",e),required: "Email is Required",
      pattern:{
        value:/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message : `Invalid email address`
      }})}}
      callback={(e)=>console.log(e)}
      name={"email"}
      ></InputField>
      <p className='fogot_password clr_blue' onClick={()=>{
            callback('reset')
          }}>Forgot password?</p>
      <InputField 
      placeholder={"Enter Password"}
      label={"Password"}
      label_class={"label_styles"}
      mandatory={false}
      input_class={"inputBox_styles edgeEyeHide"}
      type={"password"}
      id={"changeType"}
      errorsmsg={errors?.password?.message}
      children={{...register("password",{onChange:(e)=>handleChange("password",e),required: "Password is Required"})}}
      callback={(e)=>console.log(e)}
      name={"password"}
      container={"input_icon_styles"}
      icon_childer={true}
      ></InputField>
                <Box sx={{display:"flex",flexDirection:"row",justifyContent:"start",alignItems:"center",alignSelf:"start"}}> 
        <Checkbox style={{paddingLeft:0}}
         checked={isToggled} 
         name='rememberMe'
        {...register("rememberMe",{onChange:(e)=>setisToggled(e.target.checked)})}
         />
          <Typography className='Remember_me'>Remember me</Typography> </Box>
        <Button variant="contained" className='btn_color' type='submit'    fullWidth>Sign In</Button>
      </form>
      
      <p className='note_info2'>Don’t have an account yet?<span className='clr_blue' onClick={()=>{
            callback('register') 
          }}> Sign Up</span></p>
    </div>

  </div>
    
    </>
  )
}


export default LoginPageNew